import { useCallback, useEffect, useRef, useState } from 'react';

export function useCallDuration() {
  const [duration, setDuration] = useState(0);
  const [isRunning, setIsRunning] = useState(false);
  const [startTime, setStartTime] = useState(0);
  const interval = useRef<ReturnType<typeof setInterval>>();

  useEffect(() => {
    if (startTime > 0) {
      interval.current = setInterval(() => {
        setDuration(() => Date.now() - startTime);
      }, 1000);
    } else {
      interval.current && clearInterval(interval.current);
      interval.current = undefined;
    }
  }, [startTime]);

  const reset = () => {
    setDuration(0);
    setIsRunning(false);
    setStartTime(0);
  };

  const start = useCallback(() => {
    reset();
    setStartTime(Date.now());
    setIsRunning(true);
  }, []);

  const stop = () => {
    setIsRunning(false);
    setStartTime(0);
  };

  const padStart = (num: number) => {
    return num.toString().padStart(2, '0');
  };

  const formatTime = (time: number) => {
    // todo: probably should consider hour
    const seconds = Math.floor(time / 1000);
    const minutes = Math.floor(seconds / 60);

    const roundedMinutes = minutes % 60;
    const roundedSeconds = seconds % 60;

    return `${padStart(roundedMinutes)}:${padStart(roundedSeconds)}`;
  };

  return {
    duration,
    isRunning,
    start,
    stop,
    formattedTime: formatTime(duration),
    startTime,
  };
}
